<!-- 采购退货数据操作 -->
<template>
   <div>
      <div v-if="isLoaded">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
               <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val)=>{showTabs=val}" @tabHeight="tabHeight">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主要信息 -->
                        <div v-if="scope.index == 0">
                           <el-form label-width="100px" id="mainInfo" class="baseForm" ref="sendDataInfo" :model="sendDataInfo" size="mini" :show-message="false">
                              <el-row v-if="dataActionBox.actionType!=2">
                                 <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey" v-if="formOneValue.isShow==1"
                                               :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <!-- 记账单号 -->
                                    <el-tooltip v-if="formOneValue.fieldType == 'extract'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)"
                                                 :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                          <el-button @click="openExComponents(formOneValue.extractId, formOneKey, formOneValue.entityField,formOneValue.nosetField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange==0 || dataActionBox.actionType == 1">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                       <el-input class="form_codition" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                 @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)"
                                                 :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                    </el-tooltip>
                                    <!-- 退货申请日期 -->
                                    <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" v-model="sendDataInfo[formOneValue.entityField]"
                                             :isdisabled="formOneValue.isChange == 0" :isShowLong="false"></df-date>
                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                               :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2" @change="$forceUpdate()" v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                       <el-option v-for="item in JSON.parse(
													formOneValue.formatterContent
												)" :key="item.key" :label="item.key" :value="item.value">
                                       </el-option>
                                    </el-select>
                                    <!-- 退货原因 -->
                                    <el-input class="form_codition" clearable v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)"
                                              v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                 </el-form-item>
                              </el-row>
                              <el-row v-if="dataActionBox.actionType==2">
                                 <el-form-item :label="formOneValue.showField+':'" :prop="formOneValue.entityField" v-for="(formOneValue,formOneKey) in scope.row.jurconfigform" :key="formOneKey"
                                               v-if="formOneValue.isShow==1" :rules="formOneValue.isRequired == 1 ? [{required: formOneValue.isChange == 1, trigger: ['blur', 'change']}] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)+':'"></label>
                                    <span v-if="formOneValue.isRift == 1">
                                       <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField]}}</a>
                                    </span>
                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                       <span v-if="sendDataInfo[formOneValue.entityField]">
                                          {{
								$common.getLocalTime(sendDataInfo[formOneValue.entityField])
							}}
                                       </span>
                                    </span>
                                    <span v-else-if="formOneValue.entityField == 'isWms' || formOneValue.entityField == 'isPay'">{{sendDataInfo[formOneValue.entityField] == 1 ? "是" : "否"}}</span>
                                    <span v-else>{{sendDataInfo[formOneValue.entityField]}}</span>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                           <el-form :inline="true" size="mini" @submit.native.prevent>
                              <div id="operateBtn" v-if="dataActionBox.actionType!=2">
                                 <el-button type="primary" size="mini" @click="deleteDetails()">删除</el-button>
                              </div>
                              <el-table size="mini" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" :data="sendDataInfo.detailAdd"
                                        border style="width: 100%" :height="mxHeight">
                                 <el-table-column label="选择操作" width="90" v-if="dataActionBox.actionType!=2">
                                    <template slot-scope="scope">
                                       <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                          <i class="el-icon-thumb"></i>
                                       </el-radio>
                                    </template>
                                 </el-table-column>
                                 <el-table-column align="center" :prop="formOneValue.entityField" show-overflow-tooltip :min-width="formOneValue.fieldWeight" :label="formOneValue.showField"
                                                  v-for="(formOneValue,formOneKey) in mxForm" :key="formOneKey" v-if="formOneValue.isShow==1">
                                    <template slot-scope="scope">
                                       <span v-if="formOneValue.fieldType == 'date'">
                                          <span v-if="scope.row[formOneValue.entityField]">
                                             {{$common.getLocalTime(scope.row[formOneValue.entityField])}}
                                          </span>
                                       </span>
                                       <el-input v-else-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo.detailAdd[scope.$index][formOneValue.entityField]" :ref="formOneValue.entityField"
                                                 :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField,formOneValue.setField)"
                                                 :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                          <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField,formOneValue.setField)" slot="append" icon="el-icon-search"
                                                     :disabled="formOneValue.isChange == 0  || dataActionBox.actionType == 2">
                                          </el-button>
                                       </el-input>
                                       <span v-else-if="formOneValue.isRift == 1">
                                          <a @click="toDetail(scope.row[formOneValue.riftField])">{{scope.row[formOneValue.entityField]}}</a>
                                       </span>
                                       <input v-else-if="formOneValue.entityField == 'rgdRetnumber' && dataActionBox.actionType!=2" :ref="formOneValue.entityField"
                                              @keyup.enter="tableNextFocus(formOneValue.focusField,scope.$index)" clearable class="newInput" @input="calculation()" type="number" :min="0"
                                              v-model="sendDataInfo.detailAdd[scope.$index][formOneValue.entityField]" :maxlength="$store.state.inputLength" />
                                       <span v-else-if="formOneValue.entityField == 'bgmId'">{{sendDataInfo.detailAdd[scope.$index].bgmName}}</span>
                                       <span v-else>
                                          {{sendDataInfo.detailAdd[scope.$index][formOneValue.entityField]}}
                                       </span>
                                    </template>
                                 </el-table-column>

                              </el-table>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val)=>{mxHeight=val}"></tree>
            <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
         </div>
      </div>
      <el-dialog top="1vh" :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <ExtractionScheme :extractParamsData="extractParamsData" ref="ExtractionScheme" :ppId="ppId" :id="exId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
         <!-- 原：p-sReturnExtractionScheme :extractData="extractData1"  -->
      </el-dialog>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <printPlan ref="printPlan"></printPlan>
      <div v-show="false">{{ some }}</div>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
export default {
   name: "rgApplynoticesAction",
   props: ["actionData"],
   //import引入的组件需要注入到对象中才能使用
   components: {
      ExtractionScheme,
      SearchScheme
   },
   data() {
      //这里存放数据
      return {
         dataActionBox: {
            showStatus: false,
            openMode: "ltr" || "rtl",
            boxTitle: "新增" || "编辑",
            actionType: 0, // 0新增，1修改
         },
         sendDataInfo: {},
         selectedDetails: [],
         selectedDetailsIndex: 0,
         selectGoodsInfo: "",
         showTabs: "",
         formDataList: [],
         dictionariesData: {},
         userOneList: [],
         goodsList: [],
         editDateilsIndex: "",
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: "",
         smId: "",
         ppId: "",
         isLoaded: false,
         mxHeight: 0,
         dictionariesDatas: [], //退货原因
         mxForm: [],
         tabForm: [],
         footForm: [],
         sField: '', // 赋值字段
         fField: '', //焦点字段
         nosField: '', // 不可赋值字段
         inputel: '', //所有input对象
         seTitle: "", //检索
         DialogVisible: false,
         seId: 0,
         seType: "",
         seIndex: 0,
         seIndex1: 0,
         seWidth: '',
         parentSearchData: {},
         selectedRow: [], // 当前已选择行
         extractParamsData: {},
         some: 0,
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "sendDataInfo.detailAdd": {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.totalCount = 0; //总条目数
            this.sendDataInfo.totalMoney = 0; // 总金额
            this.sendDataInfo.totalNumber = 0; // 总数量
            newValue.forEach((item, keys) => {
               let a = item.rgdRetnumber
               if (item.rgdRetnumber == '') {
                  item.rgdRetnumber = 0
               } else if (a.length > 1 && a.substring(0, 1) == "0" && a.substring(1, 2) != ".") {
                  item.rgdRetnumber = a.substring(1, a.length)
               }
               if (item.rgdRetnumber <= 0) {
                  this.sendDataInfo.detailAdd[keys].money = 0;
                  this.sendDataInfo.detailAdd[keys].psmoney = 0;
                  return false;
               }
               if (item.rgdRetnumber > item.rgdOldnumber) {
                  return this.$message({
                     message: "退货数量不能大于原单数量",
                     type: "error",
                  });
               }

               // 计算金额 单价*数量
               this.sendDataInfo.detailAdd[keys].money =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.price, item.rgdRetnumber)
                  );

               // 计算含税金额 含税价格*数量
               this.sendDataInfo.detailAdd[keys].psmoney =
                  this.$common.getDecimalInfo(
                     3,
                     NP.times(item.psprice, item.rgdRetnumber)
                  );

               this.sendDataInfo.totalMoney = NP.plus(
                  this.sendDataInfo.totalMoney,
                  this.sendDataInfo.detailAdd[keys].psmoney
               );

               this.sendDataInfo.totalNumber = NP.plus(
                  this.sendDataInfo.totalNumber,
                  item.rgdRetnumber
               );
            });
            this.sendDataInfo.totalCount = newValue.length;
         },
         deep: true,
      },
      "sendDataInfo.dismode": {
         handler: function (newstr, oldValue) {
            this.$nextTick(() => {
               let newValue = newstr.replace(/\s*/g, "");
               this.sendDataInfo.dismode = newValue
               if (newValue != "物流" || newValue == '') {
                  this.sendDataInfo.companyName = ''
                  this.sendDataInfo.loId = ''
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        item.isShow = 0;
                     }
                  })
               } else {
                  this.tabForm[0].jurconfigform.forEach((item) => {
                     if (item.entityField == "companyName") {
                        item.isShow = 1;
                     }
                  });
               }

            })
            this.some++
            this.$forceUpdate();
         },
         deep: true,
      },
   },
   //方法集合
   //方法集合
   methods: {
      tabHeight(val) {
         this.mxHeight = val
      },
      showPrintPlan() {
         // 打印方法
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(
               this.actionData.orderId,
               this.actionData.printSouce,
               this.actionData.printJurId
            );
         } else {
            return;
         }
      },
      toDetail(orderId) {
         if (this.dataActionBox.actionType != 2) {
            this.$parent.$parent.toDetail(orderId);
         } else {
            this.$parent.$parent.$parent.toDetail(orderId);
         }
      },
      calculation() {
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.detailAdd.forEach((item) => {
            item.psprice = item.psprice ? parseFloat(item.psprice) : 0
            item.rgdRetnumber = item.rgdRetnumber ? parseFloat(item.rgdRetnumber) : 0
            item.ppargdRetnumberdNum = item.ppargdRetnumberdNum ? parseFloat(item.ppargdRetnumberdNum) : 0

            // 含税金额
            item.psmoney = this.$common.getDecimalInfo(
               3,
               NP.times(item.psprice, item.rgdRetnumber)
            );
            // 金额
            item.money = this.$common.getDecimalInfo(
               3,
               NP.times(item.price, item.ppargdRetnumberdNum)
            );
            this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(
               3,
               NP.plus(this.sendDataInfo.totalMoney, item.psmoney)
            );
            this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(
               1,
               NP.plus(this.sendDataInfo.totalNumber, item.rgdRetnumber)
            );
         });
         this.sendDataInfo.totalCount =
            this.sendDataInfo.detailAdd.length;
      },
      // 主表单select框切换enter切换焦点事件方法
      selectChange(e) {
         if (e == false) {
            for (let index = 0; index < this.inputel.length; index++) {
               if (this.inputel[index] == document.activeElement) {
                  this.nextFocus(index);
                  break;
               }
            }
         }
      },
      onInput() {
         this.$forceUpdate();
      },
      async getDataByChen(val) {
         let reVal = JSON.parse(JSON.stringify(val))
         console.log("fanhui", reVal);
         if (reVal != "" || reVal != undefined) {
            for (let key in reVal) {
               if (key == "arrlistbychen") {
                  this.sendDataInfo.detailAdd = reVal.arrlistbychen;
               } else {
                  this.sendDataInfo[key] = reVal[key];
               }
            }
            this.sendDataInfo.detailAdd.forEach((item) => {
               item.rgdOldnumber = item.psbkdIsnumber;
               item.rgdRetnumber = item.psbkdIsnumber;
            });
            this.DialogExtract = false
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            this.$nextTick(() => {
               this.selectedDetailsIndex = 0
               this.tableNextFocus('rgdRetnumber', this.selectedDetailsIndex)
               let refsElTable = this.$refs.mxTableRef
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex]);
               // this.nextFocus(this.seIndex)
            })
         }
      },
      getSeWidth(e) {
         this.seWidth = e + "%";
      },
      getWidth(e) {
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         this.seTitle = e;
      },
      getExtractName(e) {
         this.exTitle = e;
      },
      // 提取方案Id, 索引(表格中), 标识
      openExComponents(eId, index, type) {
         removeEventListener('keyup', this.keyUp)
         this.DialogExtract = true;
         this.exId = eId;
         this.seIndex = index;
         this.seType = type;
         this.ppId = "psbkmId";
         this.extractParamsData[type] = this.sendDataInfo[type]
         this.extractData1 = {
            id: this.exId,
            ppId: this.ppId,
            idType: "ormId",
         };
      },
      // 检索Id, 索引(表格中), 标识
      //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
      openSearch(sId, index, type, sField, fField, nosField) {
         if (type == "stName") {
            this.parentSearchData.lotno = this.sendDataInfo.detailAdd[this.seIndex].lotno;
            this.parentSearchData.stName = this.sendDataInfo.detailAdd[this.seIndex].stName;
         }
         if (type == "saiAddress") {
            this.parentSearchData.smId = this.sendDataInfo.smId
         }
         removeEventListener('keyup', this.keyUp)
         this.DialogVisible = true;
         this.seId = sId;
         this.seIndex1 = index;
         this.seType = type;
         this.sField = sField
         this.fField = fField
         this.nosField = nosField
         this.parentSearchData[type] = this.sendDataInfo[type]
      },
      // 获取主表单所有input
      getMainInput() {
         var el = document.getElementById('mainInfo')
         if (el) this.inputel = el.getElementsByTagName('input')
      },
      changeInputModel(val) {
         // console.log('fanhui', val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            if (this.seType == "stName") {
               // 	this.sendDataInfo.detailAdd[this.selectedDetailsIndex].stId = val.stId;
               // 	this.sendDataInfo.detailAdd[this.selectedDetailsIndex].stName = val.stName;
               let arr = this.sField.split(',')
               arr.forEach(item => {
                  this.sendDataInfo.detailAdd[this.selectedDetailsIndex][item] = val[item]
               })

            } else {
               this.paramValue(val)
            }
         }
      },
      // 赋值字段
      paramValue(val) {
         console.log(this.sField);
         let arr = this.sField.split(',')
         arr.forEach(item => {
            this.sendDataInfo[item] = val[item]
         })
         console.log(this.sendDataInfo);
         this.$nextTick(() => {
            this.nextFocus(this.seIndex1)
         })
      },
      // 输入框切换焦点
      nextFocus(index) {
         console.log(index)
         if (index >= (this.inputel.length - 1)) {
            if (this.sendDataInfo.detailAdd.length > 0) this.tableNextFocus('rgdRetnumber', this.selectedDetailsIndex)
            return
         }
         var aindex = index + 1
         if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
            this.nextFocus(aindex)
            return
         }
         this.inputel[aindex].focus()
      },
      // 表格切换焦点方法
      tableNextFocus(field, index) {
         if (field == '') return
         if (field == 'keydown') {
            if (index == this.sendDataInfo.detailAdd.length - 1) return
            if (this.sendDataInfo.detailAdd[index + 1] != undefined) {
               this.$refs['rgdRetnumber'][index + 1].focus() //跳退货数量
               this.selectedDetailsIndex = index + 1
               this.$nextTick(() => {
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex]);
               })
               return
            }
         }
         this.$refs[field][index].focus()
      },
      // 初始化焦点
      initFocus() {
         for (let index = 0; index < this.inputel.length; index++) {
            if (this.inputel[index].value == '') {
               this.inputel[index].focus()
               break
            }
         }
      },
      // 监听键盘事件
      keyUp(e) {
         if (e.key == 'F1') { // 右键新增明细
            e.preventDefault();
            // this.addDetail('sendDataInfo')
            return
         } else if (e.key == 'F2') {
            e.preventDefault();
            this.deleteDetails()
         } else if (e.keyCode == 40) { // 下键
            // 表格为空，不执行下方 
            if (this.sendDataInfo.detailAdd.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == this.sendDataInfo.detailAdd.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                  this.selectedDetailsIndex = 0
               } else { // 正常递增
                  this.selectedDetailsIndex++
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex], false);
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         } else if (e.keyCode == 38) { // 上键
            if (this.sendDataInfo.detailAdd.length == 0) return
            let refsElTable = this.$refs.mxTableRef
            this.$nextTick(() => {
               if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                  this.selectedDetailsIndex = 0
               } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                  this.selectedDetailsIndex = this.sendDataInfo.detailAdd.length - 1
               } else { // 正常递减
                  this.selectedDetailsIndex--
               }
               if (!refsElTable) return
               let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
               //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
               if (findRow && this.selectedRow.length === 1) {
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex], false);
                  return;
               }
               // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
               refsElTable.clearSelection();
               refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex]); // 把现在当前行勾选
            })
         }

      },
      closeChild() {
         addEventListener('keyup', this.keyUp)//创建监听键盘事件
      },
      // 表格方法
      rowClassName({ row, rowIndex }) {
         let rowName = "",
            findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
         if (findRow) {
            rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
         }
         return rowName; //也可以再加上其他类名 如果有需求的话
      },

      // 选中行底色逻辑
      rowStyle({ row, rowIndex }) {
         Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
            value: rowIndex,
            writable: true,
            enumerable: false
         });
         let rowBackground = {}
         if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
         return rowBackground
      },

      // 明细表格点击选中
      clickEvent(row, column, event, params) {
         let refsElTable = this.$refs.mxTableRef; // 获取表格对象
         let findRow = {}
         this.selectedDetailsIndex = row.rowIndex
         findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
         //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
         if (findRow && this.selectedRow.length === 1) {
            refsElTable.toggleRowSelection(row, false);
            return;
         }
         // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
         refsElTable.clearSelection();
         refsElTable.toggleRowSelection(row);
      },

      // 保存已选择行
      handleSelectionChange(rows) {
         this.selectedRow = rows; // 保存已选择行
      },

      // 选择采购员
      selectUserOne(data) {
         data.forEach((item) => {
            if (item.opmId == this.sendDataInfo.rgamPurchaser) {
               this.sendDataInfo.rgamSapdept = item.depId;
               this.sendDataInfo.rgamSapdeptName = item.depName;
            }
         });
      },

      initActionBox() {
         this.$confirm("确定取消新增吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(() => {
               this.$common.delOrderInfo(this.sendDataInfo.psbkmId)
               this.init();
               this.dataActionBox.actionType = 0;
               this.$emit("drawerCancel");
            })
            .catch(() => { });
      },
      init() {
         for (let key in this.sendDataInfo) {
            this.sendDataInfo[key] = "";
         }
         this.sendDataInfo.detailAdd = [];
         this.sendDataInfo.totalMoney = 0;
         this.sendDataInfo.totalNumber = 0;
         this.sendDataInfo.totalCount = 0;
      },
      // 默认值
      initDefaultValue() {
         let arr = this.formDataList[0].jurconfigform
         arr.forEach(item => {
            if (item.defaultValue != 'null' && item.defaultValue != null && item.defaultValue != '') {
               this.sendDataInfo[item.entityField] = item.defaultValue
            }
         })
         this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
      },
      // 提取采购退货草稿
      async extractData(data) {
         if (data.length >= 1) {
            var sendData = [];
            data.forEach((items) => {
               sendData.push(items.psbkdId);
            });
            let responseData = await this.$http.extractPurchaseListOrder({
               ids: sendData,
            });
            if (responseData.status == 200) {
               this.sendDataInfo = responseData.result;
               this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         }
      },

      async isShowData(name, value) {
         console.log(name);
         switch (name) {
            case "businessGoods":
               var dataInfo = sessionStorage.getItem("selectBusinessGoodsEntryInfo");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.detailAdd.push({
                     bgmId: dataInfo.bgmId,
                     bgmName: dataInfo.bgmName,
                     packingInfo: packingInfo,
                     batchNumber: "",
                     cartonSize: "",
                     condId: 0,
                     unitPrice: 0,
                     bgfIntaxrate: dataInfo.busgoodfinance.bgfIntaxrate,
                     originalOrderAmount: 0,
                     packingUnit: "",
                     producedData: "",
                     remark: "",
                     returnAmount: 0,
                     rgdReserves1: "",
                     rgdReserves2: "",
                     rgdReserves3: "",
                     rgdReserves4: "",
                     rgdReserves5: "",
                     rgdReserves6: "",
                     taxAmount: 0,
                     taxPrice: 0,
                     validityData: "",
                  });
               }
               break;

            case "supplier":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.rgamRapcus = dataInfo.smId;
                  this.sendDataInfo.rgamRapcusName = dataInfo.smName;
               }
               console.log(dataInfo);
               break;

            case "cargoOwner":
               var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
               console.log(dataInfo);
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.sendDataInfo.coId = dataInfo.coId;
                  this.sendDataInfo.coName = dataInfo.coName;
               }

               break;
         }
      },
      //父级传入
      openBox() {
         this.dataActionBox.actionType = this.actionData.cate;
         this.formDataList = this.actionData.formData;
         this.filterMainField()
         var oldData = this.actionData.oldData;
         this.showTabs = this.actionData.formData[0].jciName;
         this.init();
         this.getSpecialUser();
         this.getPartDictionariesData();
         this.sendDataInfo.rgamRapdate = this.$moment().valueOf();
         if (this.dataActionBox.actionType == 0) {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.initDefaultValue()
         } else if (this.dataActionBox.actionType == 1) {
            this.dataActionBox.boxTitle = "编辑信息";
            this.dataActionBox.openMode = "rtl";
            for (let key in oldData) {
               this.$set(this.sendDataInfo, key, oldData[key])
            }
         } else {
            this.dataActionBox.boxTitle = "查看信息";
            var dataInfo = JSON.parse(JSON.stringify(oldData));
            for (let key in dataInfo) {
               this.$set(this.sendDataInfo, key, dataInfo[key])
            }
         }
         this.$nextTick(() => {
            setTimeout(() => {
               if (this.dataActionBox.actionType != 2) {
                  this.mxHeight = this.$common.getBtnHeight()
               } else {
                  this.$refs['tree'].init(this.sendDataInfo.rganomId)
                  this.mxHeight = this.$common.getHeight()
               }
               this.initFocus()
            }, 16.7)
         });
      },
      sendDataAction() {
         this.$refs['sendDataInfo'].validate(async (valid) => {
            if (valid) {
               if (this.sendDataInfo.detailAdd.length <= 0) {
                  this.$message({
                     message: "请添加明细",
                     type: "error",
                  });
                  return false;
               }

               let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
               if (this.dataActionBox.actionType == 0) {
                  var responseData = await this.$http.addRgApplynotices(sendData);
               } else {
                  var responseData = await this.$http.modifyRgnoticeRgApplynotices(sendData);
               }
               if (responseData.status == 200) {
                  this.$message({
                     message: "操作成功",
                     type: "success",
                  });
                  this.$emit("drawerCancel");
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            } else {
               return this.$message({
                  message: "请完善主信息",
                  type: "error",
               });
            }
         });

      },

      deleteDetails(index) {
         if (this.sendDataInfo.detailAdd.length > 0) {
            if (this.selectedDetailsIndex === "") {
               return this.$message({
                  message: "请先选中明细",
                  type: "warning",
               });
            } else {
               this.sendDataInfo.detailAdd.splice(
                  this.selectedDetailsIndex,
                  1
               );
               this.$nextTick(() => {
                  if (this.sendDataInfo.detailAdd.length > 1) {
                     if (this.selectedDetailsIndex != 0) {
                        this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1)
                     } else {
                        this.selectedDetailsIndex = 0
                     }
                     this.tableNextFocus('rgdRetnumber', this.selectedDetailsIndex)
                  } else {
                     this.selectedDetailsIndex = 0
                  }
                  let refsElTable = this.$refs.mxTableRef
                  refsElTable.clearSelection();
                  refsElTable.toggleRowSelection(this.sendDataInfo.detailAdd[this.selectedDetailsIndex]);
               })
            }
         } else {
            return this.$message({
               message: "暂无可删除明细",
               type: "warning",
            });
         }
      },

      // 获取供货员
      async getSpecialUser() {
         let responseData = await this.$http.getSpecialUser({ opmBuyer: 1 });
         if (responseData.status == 200) {
            this.userOneList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      // 获取字典数据
      async getPartDictionariesData() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [20, 21],
         });
         if (responseData.status == 200) {
            this.dictionariesData = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //获取退货原因
      async distributionModes() {
         let responseData = await this.$http.getCateDictionariesData({
            ids: [40],
         });
         if (responseData.status == 200) {
            this.dictionariesDatas = responseData.result;
            // console.log('退货原因',this.dictionariesDatas);
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 过滤表单不同类型
      filterMainField() {
         var mainFormList = []
         this.formDataList.forEach(item => {
            if (item.jciType == 1) {
               mainFormList.push(item)
            } else if (item.jciType == 2) {
               this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
            } else if (item.jciType == 3) {
               this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
            }
         })
         mainFormList.forEach((key, i) => {
            this.tabForm[i] = JSON.parse(JSON.stringify(key))
            this.tabForm[i].jurconfigform = []
            for (let index = 0; index < key.jurconfigform.length; index++) {
               this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
            }
         })
         var arr = [{ entityField: "detailAdd" }]
         var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
         for (let key in obj) {
            this.$set(this.sendDataInfo, key, obj[key])
         }
      },
   },

   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      // this.distributionModes(); //退货原因
      this.$nextTick(() => {
         this.openBox();
         this.isLoaded = true;
      });
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      addEventListener('keyup', this.keyUp)//创建监听键盘事件
   },
   beforeDestroy() {
      removeEventListener('keyup', this.keyUp)
   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.getMainInput()
   }, //生命周期 - 更新之后
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
   height: 200px;
   background-color: red;
}

.table_content_box {
   /* height: 500px !important; */
   overflow-y: auto;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
   padding-right: 20px;
}

.el-drawer {
   outline: none;
}

.mb {
   margin-bottom: 0;
}

.newInput {
   height: 28px;
   line-height: 28px;
   background-color: #fff;
   background-image: none;
   border-radius: 4px;
   border: 1px solid #dcdfe6;
   box-sizing: border-box;
   color: #606266;
   display: inline-block;
   font-size: inherit;
   outline: 0;
   padding: 0 15px;
   transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
   width: 100%;
}
</style>